/**
 * Pixel-snap для native Draw (Wave 1.2).
 */

export type LngLatTuple = [number, number];

export interface ProjectableMap {
  project(lngLat: { lng: number; lat: number }): { x: number; y: number };
}

export const DEFAULT_SNAP_PIXEL_TOLERANCE = 12;

/**
 * Возвращает ближайшую цель в пределах pixelTol или исходную точку.
 * Если совпала с `closingTarget` (обычно первая вершина) — `closed: true`.
 */
export function snapLngLatToTargets(
  map: ProjectableMap,
  lng: number,
  lat: number,
  targets: LngLatTuple[],
  options?: {
    pixelTolerance?: number;
    closingTarget?: LngLatTuple | null;
  },
): { lng: number; lat: number; snapped: boolean; closed: boolean } {
  const tol = options?.pixelTolerance ?? DEFAULT_SNAP_PIXEL_TOLERANCE;
  const cursor = map.project({ lng, lat });
  let best: LngLatTuple | null = null;
  let bestDist = Infinity;

  for (const t of targets) {
    const p = map.project({ lng: t[0], lat: t[1] });
    const d = Math.hypot(p.x - cursor.x, p.y - cursor.y);
    if (d <= tol && d < bestDist) {
      bestDist = d;
      best = t;
    }
  }

  if (!best) {
    return { lng, lat, snapped: false, closed: false };
  }

  const closing = options?.closingTarget ?? null;
  const closed =
    closing != null && best[0] === closing[0] && best[1] === closing[1];

  return { lng: best[0], lat: best[1], snapped: true, closed };
}
